import { userService } from '@/_services'
export const user = {
  namespaced: true,
  state: {
    userInfo: null,
    personalData: null,
    authenticationData: null,
    roles: [],
    offlineMode: false,
  },

  mutations: {
    setPersonalData(state, personalData){
      state.personalData = personalData
    },

    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },

    setAuthenticationData(state, data){
      state.authenticationData = data
    },

    setOfflineMode(state, data) {
      state.offlineMode = typeof data === "string" ? JSON.parse(data) : data;
      window.dispatchEvent(new CustomEvent('app:online-sync'));
    }
  },

  actions: {
    changeMode({ commit }, offlineMode ) {
      return userService.changeMode(offlineMode).then(() => {
        commit('setOfflineMode', offlineMode)
      })
    },

    loadPersonalData({ commit }){
      return userService.getMyProfile().then(data => {
        commit('setPersonalData', data)
      })
    },

    loadUser({ commit }) {
      return userService.get().then(data => {
        commit('setUserInfo', data)
        commit('setOfflineMode', data.offlineMode)
        localStorage.setItem("role", data?.type?.name)
        return data
      })
    },

    saveProfile({ dispatch }, profile){
      return userService.saveProfile(profile).then(() => {
        dispatch('loadPersonalData')
      })
    },
    
    getRole( { commit } ){
      commit
      return userService.roles().then(data => {
        localStorage.setItem("role", data[0].name)
        return data
      })
    }
  },
  
}